import { ScommesseEsitoBase } from 'components/scommesseEsitoBase';
import { SportsAvvenimentoEsposto } from 'types/swagger';
import { gtag } from 'utility/functions';
import styles from './DirettissimeCardBody.module.scss';

export type AvvenimentoDirettissime = Pick<SportsAvvenimentoEsposto, 'descrizioneTrKey' | 'descrizione'>;
export type DirettissimeCardBodyProps = {
  esitiDirettissime: string[];
};

export const DirettissimeCardBody = ({ esitiDirettissime }: DirettissimeCardBodyProps) => (
  <div className={styles.container}>
    <div className={styles.quoteContainer}>
      {esitiDirettissime?.map((esito) => (
        <ScommesseEsitoBase
          key={esito}
          keyEsito={esito}
          classNameButton={styles.minWidth}
          gtagAction={() => {
            gtag({ section: 'Sport', detail: 'Direttissime', event: 'Click quota' }, true);
          }}
        />
      ))}
    </div>
  </div>
);
